import { z } from 'zod';

export const defaultTemplateTourOperatorTypeValues = [
  'Driver',
  'Guide',
] as const;
export const defaultTemplateTourOperatorTypeSchema = z.enum(
  defaultTemplateTourOperatorTypeValues
);
export type DefaultTemplateTourOperatorType = z.infer<
  typeof defaultTemplateTourOperatorTypeSchema
>;

export const defaultMessageTemplateItemSchema = z.object({
  id: z.uuid(),
  title: z.string().nullable(),
  delayInMinutes: z.number().int().nullable(),
  templateId: z.uuid(),
  triggerStatusIds: z.array(z.uuid()),
  tourOperatorType: defaultTemplateTourOperatorTypeSchema,
  disabled: z.boolean(),
});
export type DefaultMessageTemplateItem = z.infer<
  typeof defaultMessageTemplateItemSchema
>;

export const createDefaultMessageTemplateInput = z.object({
  title: z.string().nullable().optional(),
  delayInMinutes: z.number().int().nullable().optional(),
  templateId: z.uuid(),
  triggerStatusIds: z.array(z.uuid()).min(1),
  tourOperatorType: defaultTemplateTourOperatorTypeSchema,
  disabled: z.boolean().optional(),
});
export type CreateDefaultMessageTemplateInput = z.infer<
  typeof createDefaultMessageTemplateInput
>;

export const updateDefaultMessageTemplateInput = z.object({
  id: z.uuid(),
  title: z.string().nullable().optional(),
  delayInMinutes: z.number().int().nullable().optional(),
  templateId: z.uuid().optional(),
  triggerStatusIds: z.array(z.uuid()).min(1).optional(),
  tourOperatorType: defaultTemplateTourOperatorTypeSchema.optional(),
  disabled: z.boolean().optional(),
});
export type UpdateDefaultMessageTemplateInput = z.infer<
  typeof updateDefaultMessageTemplateInput
>;

export const findDefaultMessageTemplatesInput = z.object({
  offset: z.number().int().nonnegative().optional(),
  limit: z.number().int().min(1).max(200).optional(),
  title: z.string().optional(),
  tourOperatorType: defaultTemplateTourOperatorTypeSchema.optional(),
  disabled: z.boolean().optional(),
});
export type FindDefaultMessageTemplatesInput = z.infer<
  typeof findDefaultMessageTemplatesInput
>;

export const findDefaultMessageTemplatesResultSchema = z.object({
  data: z.array(defaultMessageTemplateItemSchema),
  count: z.number().int().nonnegative(),
  countAll: z.number().int().nonnegative(),
});
export type FindDefaultMessageTemplatesResult = z.infer<
  typeof findDefaultMessageTemplatesResultSchema
>;

export const deleteDefaultMessageTemplateInput = z.object({ id: z.uuid() });
export type DeleteDefaultMessageTemplateInput = z.infer<
  typeof deleteDefaultMessageTemplateInput
>;

export const deleteDefaultMessageTemplateResultSchema = z.object({
  id: z.uuid(),
});
export type DeleteDefaultMessageTemplateResult = z.infer<
  typeof deleteDefaultMessageTemplateResultSchema
>;
